// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2MsDE","error":"Textarea_error__12Lyq","readonly":"Textarea_readonly___I1Ej","disabled":"Textarea_disabled__1O7gh"};